export const approvalHeading = [
  "Service",
  "Cost",
  "Date needed",
  "Requester",
  "Status",
];

export const tableData = [
  {
    service: "Service Name 1",
    cost: 1000,
    date_needed: "2025-10-15",
    requester: {
      name: "John Doe",
      role: "Manager",
      image: "/path/to/image.jpg"
    },
    status: "Pending"
  },
  {
    service: "Service Name 2",
    cost: 2500,
    date_needed: "2025-11-01",
    requester: {
      name: "Jane Smith",
      role: "Developer",
      image: "/path/to/image.jpg"
    },
    status: "Approved"
  },
  {
    service: "Service Name 3",
    cost: 750,
    date_needed: "2025-09-30",
    requester: {
      name: "Bob Johnson",
      role: "HR",
      image: "/path/to/image.jpg"
    },
    status: "Declined"
  },
  {
    service: "Service Name 4",
    cost: 1500,
    date_needed: "2025-10-20",
    requester: {
      name: "Alice Brown",
      role: "Designer",
      image: "/path/to/image.jpg"
    },
    status: "Pending"
  },
  {
    service: "Service Name 5",
    cost: 3000,
    date_needed: "2025-12-05",
    requester: {
      name: "Charlie Wilson",
      role: "Sales",
      image: "/path/to/image.jpg"
    },
    status: "Approved"
  },
];